import React, { Component } from 'react';

export class CheckboxInput extends Component {
  render() {
    return (
      <div className="control-group boolean optional">
        <label className="boolean optional control-label">{this.props.name}</label>
        <div className="controls">
          <input type="checkbox" checked={this.props.checked} onChange={this.props.onChange} id={this.props.id}/>
        </div>
      </div>
    )
  }
}